var React = require('react');

function IconStarFull (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_1384","data-name":"Path 1384","d":"M1740,504.514l2.715,8.785h8.785l-7.107,5.43,2.715,8.785-7.107-5.43-7.107,5.43,2.715-8.785-7.107-5.43h8.785Z","transform":"translate(-1728 -504.014)","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1"}));
}

IconStarFull.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconStarFull;

IconStarFull.default = IconStarFull;
